import { useWorkbookAccessSetup } from "@/payroll/workbook-access/use-workbook-access-setup";
import { WorkbookAccessNextStep } from "@/payroll/workbook-access/workbook-access-next-step";
import { EmptySheetState } from "./empty-sheet-state";

interface NoVisibleSheetsStateProps {
  businessId: string | null;
  fillHeight?: boolean;
}

export const NoVisibleSheetsState = ({
  businessId,
  fillHeight,
}: NoVisibleSheetsStateProps) => {
  const { isUnconfigured, canManage, nextStep } =
    useWorkbookAccessSetup(businessId);
  const action = nextStep && (
    <WorkbookAccessNextStep
      nextStep={nextStep}
      isUnconfigured={isUnconfigured}
    />
  );

  if (isUnconfigured)
    return (
      <EmptySheetState
        title="Workbook access isn't set up yet"
        description={
          canManage
            ? "Choose who can see each sheet of the Grid in workbook access settings."
            : "Volca sets this up for your business. Contact support to choose who can see each sheet of the Grid."
        }
        fillHeight={fillHeight}
        action={action}
      />
    );

  return (
    <EmptySheetState
      title="No Grid sheets shared with you"
      description={
        canManage
          ? "Choose who can see each sheet of the Grid in workbook access settings."
          : "Ask a manager to share the sheets you need."
      }
      fillHeight={fillHeight}
      action={action}
    />
  );
};
